var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"level-img-wrap"},[_c('b-img',{staticClass:"level-img",attrs:{"src":require('@/assets/level_t.jpg')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }